export default __webpack_public_path__ + "static/media/notification-black.99751df5.svg";